import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Popover } from 'primeng/popover';

import { AuthFlow } from '@auth/models/auth';
import { AuthService } from '@auth/services/auth.service';
import { ProducerService } from '@core/services/producer.service';
import { RouterService } from '@core/services/router.service';

import { SafePipe } from '../../pipes/safe.pipe';
import { ProfileOverlay } from '../profile-overlay/profile-overlay';
import { ButtonSize, ButtonType, YButton } from '../y-button/y-button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'yt-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  imports: [YButton, RouterLinkActive, RouterLink, Popover, ProfileOverlay, TranslateModule, SafePipe],
  standalone: true
})
export class Header {
  private readonly producerService = inject(ProducerService);
  private readonly authService = inject(AuthService);
  private readonly routerService = inject(RouterService);

  readonly authUser = this.authService.authUser;
  readonly producer = this.producerService.producer;
  readonly producerUser = this.producerService.producerUser;

  readonly color = input<'light' | 'dark'>('dark');
  readonly navItems = signal([
    { label: 'Dashboard', routerLink: '/dashboard' },
    { label: 'My_Menu', routerLink: '/my-menu' },
    { label: 'Orders', routerLink: '/orders' },
    { label: 'Producer_Profile', routerLink: '/producer-profile' }
  ]);
  readonly isNavbarOpen = signal(false);

  readonly ButtonSize = ButtonSize;
  readonly ButtonType = ButtonType;

  toggleNavbar() {
    this.isNavbarOpen.set(!this.isNavbarOpen());
  }

  async login() {
    const user = await this.authService.login(AuthFlow.SignIn);
    // Enter the app on a successful sign-in; the status guards route an Active producer to the dashboard and send
    // anyone else (new, or mid-onboarding) to onboarding.
    if (user) {
      await this.routerService.navigate(['/dashboard']);
    }
  }
}
